import * as Yup from 'yup';
import { API_BASE_URL, APP_POOL_CONFIG } from '@synergy/config';
import { Box, Stack, styled } from '@mui/material';
import { Form, Formik } from 'formik';
import { FormattedMessage } from 'react-intl';
import { ReactElement, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { ConfirmUserForm } from './confirm-user-form';
import { ConfirmUserSuccess } from './confirm-user-success';
import { LoginApi } from '../common/api/login-api';
import { PhoneLink } from '../common/components/phone-link/phone-link';
import Footer from '../common/components/footer/footer';

const Content = styled(Stack)(({ theme }) => ({
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,

    [theme.breakpoints.down('sm')]: {
        paddingTop: theme.spacing(8),
    },
}));

const StyledForm = styled(Form)(({ theme }) => ({
    gap: theme.spacing(3),
    maxWidth: 300,
}));

interface ConfirmPasswordData {
    password: string;
    passwordConfirmation: string;
    agb: boolean;
}

export const ConfirmUser = (): ReactElement => {
    const [searchParams] = useSearchParams();
    const [statusCode, setStatusCode] = useState<string | null>(null);
    const [apiCallSuccess, setApiCallSuccess] = useState(false);

    const newPasswordApi = new LoginApi(API_BASE_URL);

    const initialValues: ConfirmPasswordData = {
        password: '',
        passwordConfirmation: '',
        agb: false,
    };

    const schema = Yup.object().shape({
        password: Yup.string().required('app.error.required').min(8, 'app.newPassword.charactersRequired'),
        passwordConfirmation: Yup.string()
            .required('app.error.required')
            .min(8, 'app.newPassword.charactersRequired')
            .oneOf([Yup.ref('password'), null], 'app.newPassword.passwordsNotMatching'),
        agb: Yup.boolean().isTrue('app.error.approval'),
    });

    const handleSubmit = async (values: ConfirmPasswordData) => {
        setStatusCode(null);

        if (searchParams.has('token')) {
            const token = searchParams.get('token') ?? '';
            const response = await newPasswordApi.setPassword(token, values.password);
            if (response.success) {
                setApiCallSuccess(true);
            } else {
                setStatusCode('400');
            }
        } else {
            setStatusCode('400');
        }
    };

    return (
        <>
            <Content>
                <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={schema}>
                    <StyledForm noValidate={true}>
                        {apiCallSuccess ? <ConfirmUserSuccess /> : <ConfirmUserForm statusCode={statusCode} />}
                    </StyledForm>
                </Formik>
            </Content>
            <Footer>
                <Box>
                    <FormattedMessage
                        id="app.footer.questions"
                        values={{ poolConfigNameShort: APP_POOL_CONFIG['name_short'] }}
                    />{' '}
                    <PhoneLink />
                </Box>
            </Footer>
        </>
    );
};
